<template>
	<div>
		<v-dialog
			v-model="dialog"
			scrollable
			max-width="1200"
			height="800"
			:fullscreen="$vuetify.breakpoint.xs ? true : false"
			:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
			@click:outside="$emit('close')"
		>
			<v-card>
				<v-toolbar dark color="primary" dense>
					<v-toolbar-title style="color: white">更新履歴一覧</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn icon dark @click="$emit('close')" color="white">
						<i class="fas fa-2x fa-times" style="margin-right: 0.25rem" />
					</v-btn>
				</v-toolbar>
				<div class="table-container px-2 py-4">
					<v-data-table
						ref="tables"
						locale="ja-JP"
						:headers="headers"
						:items="fixes"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
						width="500"
					>
						<template v-slot:item="{ item }">
							<OrderConfirmationFixRecord
								:item="item"
								:authorized="authorized"
								@open="openApproveDialog($event)"
							/>
						</template>
					</v-data-table>
				</div>
				<div class="my-2" style="margin: 0 auto">
					<v-spacer></v-spacer>
					<v-btn @click="$emit('close')" color="primary"> 閉じる </v-btn>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import CommonFlame from "../../shared/CommonFlame.vue"
import OrderConfirmationFixRecord from "./OrderConfirmationFixRecord.vue"

export default {
	props: {
		fixes: {
			type: Array,
			required: false,
			default: () => [],
		},
		authorized: {
			type: Boolean,
			required: false,
		},
	},
	components: {
		CommonFlame,
		OrderConfirmationFixRecord,
	},
	data() {
		return {
			title: "更新履歴一覧",
			dialog: true,
			openDialog: false,
			headers: [
				{ text: "変更番号", value: "id", width: "150px" },
				{ text: "変更日", value: "created_at", width: "100px" },
				{ text: "作成者", value: "created_user", width: "150px" },
				{ text: "変更理由", value: "reason", width: "250px" },
				{ text: "手配元(ライニング製品の母材)", value: "source_of_base_material", width: "100px" },
				{ text: "手配可否", value: "arrangement_availability", width: "100px" },
				{ text: "支給予定日", value: "scheduled_date_of_payment", width: "100px" },
				{ text: "製品の承認予定日", value: "scheduled_date_of_approval", width: "100px" },
				{ text: "手配元(輸送)", value: "source_of_transport", width: "80px" },
				{ text: "輸送方法", value: "transport", width: "100px" },
				{ text: "塗装区分の有無", value: "exists_coating", width: "120px" },
				{ text: "塗装の補足", value: "coating_content", width: "250px" },
				{ text: "工程写真区分の有無", value: "exists_process_photo", width: "120px" },
				{ text: "工程写真の補足", value: "process_photo_content", width: "250px" },
				{ text: "水協検査区分の有無", value: "exists_water_works", width: "120px" },
				{ text: "水協検査の補足", value: "water_works_content", width: "250px" },
				{ text: "立会区分の有無", value: "exists_witness", width: "120px" },
				{ text: "立会の補足", value: "witness_content", width: "250px" },
				{ text: "梱包指定区分の有無", value: "exists_packaging", width: "120px" },
				{ text: "梱包指定の補足", value: "packaging_content", width: "250px" },
				{ text: "出荷時添付書類の有無", value: "exists_attached_file", width: "120px" },
				{ text: "出荷時添付書類の内容", value: "attached_file_content", width: "250px" },
				{ text: "生産企画部記載欄", value: "content", width: "250px" },
				{ text: "見積原価の有無", value: "exists_quotation_cost", width: "120px" },
				{ text: "受注金額入力の有無", value: "exists_order_amount", width: "120px" },
				{ text: "承認ステータス", width: "100px" },
				{ text: "承認者", width: "200px" },
			],
		}
	},
	mounted() {

	},
	methods: {
	},
}
</script>

<style lang="scss" scoped>
.v-dialog {
	display: block !important;
}
</style>
